import CountryResource from "./country.resource";

const countriesModule = angular
  .module("app.resources.country", [])
  .service("Country", CountryResource);

export default countriesModule;



// WEBPACK FOOTER //
// ./src/resources/country/country.module.js